export default "__VITE_ASSET__BJvaknMi__"